<div class="">
  <div class="main-container">
  <div class="main-content">
    <!-- Document Type Cards -->
     
    <!-- Header: back + title on the left, search + Add button on the right -->
    <div class="page-toolbar">
      <button class="back-btn" (click)="goBack()" aria-label="Go back">
        <i class="fas fa-chevron-left"></i>
      </button>
      <ng-container *ngIf="medicationData.length> 0; else emptyTitle">
        <h2 class="listMed">List Of Medications ( {{ filteredMedication.length }} )</h2>
        <div class="toolbar-actions">
          <div class="search-section">
            <div class="search-container">
              <input class="search-text" type="text" [(ngModel)]="searchText" placeholder="Search for medication..." aria-label="Search for medication">
              <i class="material-icons" aria-hidden="true">search</i>
            </div>
          </div>
          <button type="button" class="add-record-btn" (click)="openDialog()" aria-label="Add Medication">
            <i class="material-icons" aria-hidden="true">add</i>
            <span>Add Medication</span>
          </button>
        </div>
      </ng-container>
      <ng-template #emptyTitle>
        <h2 class="listMed">Medications</h2>
      </ng-template>
    </div>

    <div class="document-list">
      <!-- Display Documents -->
      <ng-container *ngIf="medicationData.length > 0; else emptyState">
            <div class="medication-grid" >
            <div class="medication-card" *ngFor="let med of filteredMedication">
              
              <div class="card-header">
                <div class="med-icon dash-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M10.5 20.5l10-10a4.95 4.95 0 0 0-7-7l-10 10a4.95 4.95 0 0 0 7 7zM8.5 8.5l7 7"/></svg></div>
                <div class="med-title-group">
                  <h3 class="med-name">{{ med.medicationName }}</h3>
                  <p class="med-info">
                    {{ med.strength }} {{ med.unit }} 
                  </p>
                </div>
                <div class="card-actions">
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onView(med)">
                      <mat-icon class="menu-view-icon" aria-hidden="true">visibility</mat-icon>&nbsp;
                      <span>View Details</span>
                    </button>
                    <button mat-menu-item (click)="onEdit(med)">
                      <!-- <mat-icon>edit</mat-icon> -->
                      <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                      <span>Edit</span>
                    </button>
                    <button mat-menu-item (click)="onDelete(med)">
                      <!-- <mat-icon>delete</mat-icon> -->
                      <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </div>

              <!-- <div class="med-condition">Condition: <strong>{{ med.medCondition }}</strong></div> -->
              <!-- <div class="med-date-range">
                From {{ med.startDate }} to {{ med.endDate || 'Ongoing' }}
              </div> -->

              <!-- <div class="med-timings" *ngIf="med.frequency === 'everyDay'">
                <label>Timings:</label>
                <ul>
                  <li *ngFor="let t of med.timeFrequency">
                    <span class="dot"></span> {{ t.time }} — {{ t.dosage }} dose
                  </li>
                </ul>
              </div> -->
              <div class="card-footer" *ngIf="med.frequency === 'everyDay'" >
                <div class="next-dose"  >
                   {{ getNextDoseTime(med) }}
                </div>

              </div>
              <div class="card-footer asNeeded" *ngIf="med.frequency != 'everyDay'" >
                   <mat-icon>repeat</mat-icon><span>As Needed</span>
              </div>

           </div>

         </div>
         
      </ng-container>
        <!-- <ng-template #emptyState>
            <div class="empty-state">
            <img src="assets/images/empty-state.png" alt="No Medications" />
            <p>No medications found. Please add some.</p>
            </div>
        </ng-template> -->

          <!-- Empty State -->
          <!-- <ng-template #emptyState>
          <div class="empty-state">
            <img class="noimg" src="assets/images/medicine.png"/>
            <h3>No Medications Added Yet..</h3>
            <p>Add new medications to keep track of your health records</p>
            <button class="add-new-btn" mat-raised-button (click)="openDialog()">
              <span class="btn-text"> + Add Medication</span>
            </button>
          </div>
          </ng-template> -->

          <ng-template #emptyState>
            <div class="empty-state-card">
              <!-- Log Img -->
              <span class="empty-tile" aria-hidden="true"><svg class="dash-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M10.5 20.5l10-10a4.95 4.95 0 0 0-7-7l-10 10a4.95 4.95 0 0 0 7 7zM8.5 8.5l7 7"/></svg></span>
               <!-- Log Title -->
               <h3>Set up Medication</h3>

              <!-- Logs Div -->
              <!-- medication -->
              <div class="empty-description">
                <div class="desc-item">
                  <img src="assets/images/medicine.png" alt="Track" />
                  <span class="trackTxt">Track all your medication</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/icons/data medis.svg" alt="Check" />
                  <span class="trackTxt">Set a schedule and be reminded</span>
                </div>
              </div>
              <!-- Logs Div ends here -->

              <!-- Log Button -->
              <button class="add-new-btn" mat-raised-button (click)="openDialog()">
                Add Medication
              </button>
              <!-- Log Button -->
            </div>
          </ng-template>
   
    </div>
  </div>

</div>
</div>